import { render, staticRenderFns } from "./DeniedProductsTable.vue?vue&type=template&id=07435ad8&"
import script from "./DeniedProductsTable.vue?vue&type=script&lang=js&"
export * from "./DeniedProductsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports